import React, { Component, Fragment } from 'react';
import DeleteLocation from './DeleteLocation';
import BootstrapTable from 'react-bootstrap-table-next';
import { NavLink } from 'react-router-dom';
import { ButtonGroup } from 'reactstrap';

function locationActions(cell, row) {
    return (
        <ButtonGroup>
            <NavLink to={`/location/${row.id}`} className='btn btn-primary'>
                <i className='fa fa-edit'> </i>
            </NavLink>
            <DeleteLocation location={row} />
        </ButtonGroup>
    );
}

const locationListColumns = [
    {
        dataField: 'name',
        text: 'Name'
    },
    {
        dataField: 'zip_code',
        text: 'PLZ'
    },
    {
        dataField: 'street',
        text: 'Straße'
    },
    {
        isDummyField: true,
        dataField: 'id',
        text: '',
        formatter: (cell, row) => locationActions(cell, row)
    },
];

export default class LocationTable extends Component {
    render() {
        const addButton = this.props.addButton;
        const customerId = this.props.customer;
        const locations = this.props.locations;
        const LocationRow = {
            renderer: row => (
                <p>
                    {row.note}
                </p>
            ),
            expanded: locations
        };
        return (
            <Fragment>
                {
                    addButton &&
                    <NavLink
                        className='btn btn-primary mb-3'
                        to={`/customer/${customerId}/location/new`}
                    >
                        Standort hinzufügen
                    </NavLink>
                }
                <BootstrapTable
                    classes='mt-3'
                    keyField='id'
                    data={locations}
                    columns={locationListColumns}
                    bootstrap4
                    condensed
                    responsive
                    expandRow={LocationRow}
                />
            </Fragment>
        )
    }
}